module.exports = __webpack_public_path__ + "static/media/lock.7641a421.svg";